import { createPinia } from 'pinia';

export const pinia = createPinia();

export * from './orders/orders.slice';
